module.exports = __webpack_public_path__ + "img/clap.5bef73a4.png";